import type { SortingState } from "@tanstack/react-table";

export const TRADE_LOG_MOBILE_SORT_OPTIONS = [
  { value: "exitDate:desc", label: "Exit date (newest)" },
  { value: "exitDate:asc", label: "Exit date (oldest)" },
  { value: "netPnL:desc", label: "P&L (high to low)" },
  { value: "netPnL:asc", label: "P&L (low to high)" },
  { value: "symbol:asc", label: "Symbol (A–Z)" },
  { value: "symbol:desc", label: "Symbol (Z–A)" },
] as const;

const MOBILE_SORT_FIELD_IDS = new Set(
  TRADE_LOG_MOBILE_SORT_OPTIONS.map((option) => option.value.split(":")[0])
);

export function sortingToMobileValue(sorting: SortingState): string {
  const sort = sorting[0];
  if (!sort) return "exitDate:desc";
  const id = sort.id === "entryDate" ? "exitDate" : sort.id;
  if (!MOBILE_SORT_FIELD_IDS.has(id)) return "exitDate:desc";
  return `${id}:${sort.desc ? "desc" : "asc"}`;
}

export function mobileValueToSorting(value: string): SortingState {
  const [id, direction] = value.split(":");
  return [{ id, desc: direction === "desc" }];
}
